import { useEffect, useRef } from "react";

const CLOUD_SET = 1200;

function CloudSet() {
  return (
    <svg className="awards-cloud-set" viewBox="0 0 1200 120" aria-hidden="true">
      <g fill="#fffaf4">
        <ellipse cx="90" cy="62" rx="54" ry="22" />
        <ellipse cx="128" cy="54" rx="36" ry="20" />
        <ellipse cx="150" cy="68" rx="28" ry="14" />
        <ellipse cx="420" cy="46" rx="70" ry="24" />
        <ellipse cx="470" cy="38" rx="40" ry="20" />
        <ellipse cx="500" cy="52" rx="34" ry="16" />
        <ellipse cx="780" cy="74" rx="62" ry="22" />
        <ellipse cx="830" cy="64" rx="38" ry="18" />
        <ellipse cx="1040" cy="40" rx="48" ry="18" />
        <ellipse cx="1080" cy="48" rx="30" ry="14" />
      </g>
    </svg>
  );
}

function Tower() {
  return (
    <svg viewBox="0 0 90 340" width="78" height="294">
      <polygon points="8,78 45,18 82,78" fill="#1f6578" />
      <rect x="16" y="74" width="58" height="46" rx="3" fill="#fffaf4" />
      <rect x="12" y="86" width="66" height="4" fill="#e08a2a" />
      <rect x="28" y="92" width="16" height="18" rx="2" fill="#d7ebe3" />
      <rect x="50" y="92" width="16" height="18" rx="2" fill="#d7ebe3" />
      <line x1="28" y1="120" x2="22" y2="330" stroke="#9a5b24" strokeWidth="5" />
      <line x1="62" y1="120" x2="68" y2="330" stroke="#9a5b24" strokeWidth="5" />
      <line x1="26" y1="190" x2="66" y2="230" stroke="#9a5b24" strokeWidth="4" />
      <line x1="26" y1="230" x2="66" y2="190" stroke="#9a5b24" strokeWidth="4" />
      <line x1="24" y1="280" x2="66" y2="280" stroke="#9a5b24" strokeWidth="4" />
    </svg>
  );
}

function Palm() {
  return (
    <svg viewBox="0 0 160 320" width="120" height="240">
      <path d="M80 310 C74 230 92 170 78 118" stroke="#9a5b24" strokeWidth="12" fill="none" strokeLinecap="round" />
      <path d="M78 130 C40 110 12 78 8 48" stroke="#1f6578" strokeWidth="8" fill="none" strokeLinecap="round" />
      <path d="M78 124 C46 96 28 52 46 22" stroke="#2f7f92" strokeWidth="8" fill="none" strokeLinecap="round" />
      <path d="M80 120 C112 92 146 58 138 24" stroke="#1f6578" strokeWidth="8" fill="none" strokeLinecap="round" />
      <path d="M80 126 C118 112 152 96 158 62" stroke="#2f7f92" strokeWidth="8" fill="none" strokeLinecap="round" />
      <path d="M78 118 C70 78 86 46 78 18" stroke="#184f5e" strokeWidth="8" fill="none" strokeLinecap="round" />
      <ellipse cx="80" cy="124" rx="14" ry="8" fill="#6d3e16" />
    </svg>
  );
}

function Umbrella() {
  return (
    <svg viewBox="0 0 180 210" width="150" height="175">
      <path d="M16 78 Q90 8 164 78" fill="#e08a2a" />
      <path d="M46 70 Q90 28 70 78" fill="#fffaf4" />
      <path d="M110 78 Q96 30 134 66" fill="#fffaf4" />
      <line x1="90" y1="78" x2="90" y2="196" stroke="#9a5b24" strokeWidth="5" />
      <path d="M90 168 Q118 168 124 150" stroke="#9a5b24" strokeWidth="4" fill="none" />
      <rect x="18" y="150" width="46" height="8" rx="2" fill="#1f6578" />
      <line x1="24" y1="158" x2="20" y2="196" stroke="#1c3d4a" strokeWidth="3" />
      <line x1="58" y1="158" x2="62" y2="196" stroke="#1c3d4a" strokeWidth="3" />
      <rect x="16" y="128" width="50" height="24" rx="3" fill="#fffaf4" />
    </svg>
  );
}

function Gull() {
  return (
    <svg viewBox="0 0 180 80" width="160" height="72">
      <path d="M8 46 Q40 8 78 40 Q92 18 112 28 Q96 36 90 48 Q120 22 172 34 Q130 40 108 52 Q96 62 78 50 Q48 66 20 54" fill="#fffaf4" stroke="#1c3d4a" strokeWidth="2" />
      <circle cx="156" cy="32" r="3" fill="#1c3d4a" />
    </svg>
  );
}

function Board() {
  return (
    <svg viewBox="0 0 90 280" width="70" height="230">
      <ellipse cx="48" cy="132" rx="22" ry="108" fill="#1f6578" transform="rotate(-8 48 140)" />
      <ellipse cx="46" cy="132" rx="8" ry="96" fill="#e08a2a" transform="rotate(-8 48 140)" />
      <ellipse cx="48" cy="250" rx="16" ry="6" fill="#c4b088" />
    </svg>
  );
}

const passers = {
  tower: Tower,
  palm: Palm,
  umbrella: Umbrella,
  gull: Gull,
  board: Board,
};

function Passer({ kind }) {
  const Shape = passers[kind];
  return (
    <div className={kind === "gull" ? "awards-passer is-gull" : "awards-passer"} aria-hidden="true">
      <Shape />
    </div>
  );
}

function AwardsDrive({ driving, passer, children }) {
  const cloudsRef = useRef(null);
  const drivingRef = useRef(driving);
  drivingRef.current = driving;

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (media.matches) {
      return undefined;
    }
    const node = cloudsRef.current;
    let frame = 0;
    let x = 0;
    let last = performance.now();
    const tick = (now) => {
      const dt = Math.min(48, now - last);
      last = now;
      const rate = drivingRef.current ? 0.72 : 0.035;
      x = (x + rate * dt) % CLOUD_SET;
      node.style.transform = `translate3d(${-x}px, 0, 0)`;
      frame = window.requestAnimationFrame(tick);
    };
    frame = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(frame);
  }, []);

  return (
    <section className={driving ? "page-banner awards-scene is-driving" : "page-banner awards-scene"}>
      <div className="awards-clouds" ref={cloudsRef}>
        <CloudSet />
        <CloudSet />
      </div>
      {passer ? <Passer kind={passer} /> : null}
      <div className="awards-sand" />
      {children}
    </section>
  );
}

export default AwardsDrive;
